export default "__VITE_ASSET__BwASbIrC__"